<template>
    <div class="firm">
        <b-row>
            <csp-desktop-firm-basedata
                :cols="8"
                :form-context="initialFormContexts.firmBasedata"
                :is-creation-form="true"/>
        </b-row>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FormContext from '@desktop/components/FormContext';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FirmBasedata from '@desktop/components/firm/detail/FirmBasedata.vue';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmCreate',
        components: {
            'csp-desktop-firm-basedata': FirmBasedata,
        },
        mixins: [FormDataMixin],
        data() {
            return {
                initialFormContexts: {
                    firmBasedata: new FormContext({
                        name: 'firmBasedata',
                        reloadFields: ['firmCategory', 'firmGroup', 'isFleetCustomer', 'isMajorCustomer'],
                        isAlwaysInEditMode: true,
                    }),
                },
            }
        },
        created() {
            const loadFunction = () => {
                return firmRepository.getBlank();
            };
            this.loadFormData(loadFunction);
        },
    }
</script>
